module.exports = __webpack_public_path__ + "img/time_to_leave.2c3c21cf.svg";